import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 30px;
`;

export const Container = styled.div`
    border: solid 2px ${ getTheme('dangerColor') };
    border-radius: 25px;
    padding: 40px 20px 20px 20px;
    width: 360px;
`;

export const Text = styled.div`
    color: ${ getTheme('dangerColor') };
    text-align: center;
`;
